$(document).ready(function(){

    var loadingElement = '<img src="data:image/gif;base64,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" />';

    let jiangs = 0;
    let jiangArray = [];
    $('.jiang').on('click',function(e){
        let status = $(this).attr('class');
        console.log(status)
        if(status == 'jiang'){
            if(jiangs > 1){
                alert('最多选择两项')
                return false
            }
            $(this).addClass('active');
            let data = $(this).attr('data');

            jiangArray.push(data);
            jiangs = jiangs + 1;
        }else{
            let data = $(this).attr('data');
            $(this).removeClass('active');
            jiangArray.splice(jiangArray.indexOf(data),1)
            jiangs = jiangs - 1;
        }
    })

    let danwei = 0;
    let danweiArray = [];
    $('.danwei').on('click',function(e){
        let status = $(this).attr('class');
        $('.danwei').removeClass('active');
        if(status == 'danwei'){
            $(this).addClass('active');
            danweiArray = [];
            let data = $(this).attr('data');
            danweiArray.push(data);
        }else{
            $(this).removeClass('active');
            danweiArray = [];
        }
        console.log(danweiArray)
        
    })

    function sum (m,n){
        　　var num = Math.floor(Math.random()*(m - n) + n);
            return num;
   }
    let sui = sum(1,100);
    let time = Date.parse(new Date());
    let sign = time+sui;

    function upFile(file,status){
        var formData = new FormData();
        formData.append('fileStream', file); 
        formData.append('label', status);

        $('.loading').show();
        $('.loadingBox').html(loadingElement);
        $('.blackBg').show();
        
        $.ajax({
            type: 'POST',
            url: "http://djyadmin.people.com.cn/api/uploadFile",
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                console.log('上传图片信息:', res)
                $('.loading').hide();
                $('.blackBg').hide();
                if(res.msg == '上传成功'){
                    if(status == "logo"){
                        alert('logo上传成功!')
                        $('#cover').val(res.data.sql)
                        $('#logo').attr({'src':res.data.sql})
                    }
                    if(status == "chengnuo"){
                        alert('承诺书上传成功!')
                        $('#chengnuo').val(res.data.sql)
                    }
                }				
            },
            error: function() {

            }
        })
    }

    $('#logoup').on('change',function(event){
        let status = "logo";
        var evt = event || window.event;
        var target = evt.target || evt.srcElement
        var files = target.files,
            file;
		
        if(files && files.length > 0) {
            // 获取目前上传的文件
            file = files[0];
            console.log('图片文件:', file)
            if(!/jpg|png|pdf/ig.test(file.name)) {
                $('.imgFile').val(null);
                alert('请上传jpg或pdf格式文件');
                return false;
            }

            upFile(file,status);
        } 
    })
    $('#chengnuoshu').on('change',function(event){
        let status = "chengnuo";
        var evt = event || window.event;
        var target = evt.target || evt.srcElement
        var files = target.files,
            file;
		
        if(files && files.length > 0) {
            // 获取目前上传的文件
            file = files[0];
            console.log('图片文件:', file)
            if(!/jpg|png|pdf/ig.test(file.name)) {
                $('.imgFile').val(null);
                alert('请上传jpg或pdf格式文件');
                return false;
            }

            upFile(file,status);
        } 
    })

    $('#getcode').on('click',function(){

        let phone = $('#tel').val();
        if(phone == ''){
            alert('手机号不能为空')
            return false
        }
        var formData = new FormData();
        formData.append('phone', phone); 

        $.ajax({
            type: 'POST',
            url: 'http://sing.people.com.cn/api/sendsms',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                // console.log('手机验证码:', res)
                alert(res.message)
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
              
            }
        })
    })

    $('#tijiao').on('click',function(){

        let name = $('#name').val();
        if(name == ''){
          alert('名称不能为空')
          return false
        }
   
        if(jiangArray.length == 0){
          alert('必须选择申报奖项类别')
          return false
        }
        let description = $('#desc').val();
        if(description == ''){
          alert('简介不能为空')
          return false
        }
        if(danweiArray.length == 0){
            alert('必须选择申报奖项类别')
            return false
          }
        let content = $('#liyou').val();
        if(content == ''){
          alert('申报理由不能为空')
          return false
        }
        let author = $('#author').val();
        if(author == ''){
          alert('填表人姓名不能为空')
          return false
        }
        let tel = $('#tel').val();
        if(tel == ''){
          alert('填表人手机号不能为空')
          return false
        }
        let code = $('#code').val();
        if(code == ''){
          alert('验证码不能为空')
          return false
        }
        let cover = $('#cover').val();
        if(cover == ''){
          alert('企业logo不能为空')
          return false
        }
        let commit_file = $('#chengnuo').val();
        if(commit_file == ''){
          alert('必须上传承诺书')
          return false
        }

        var formData = new FormData();
        formData.append('type',1);
        formData.append('feature',18);
        formData.append('title', name); 
        formData.append('articlecate', jiangArray.toString());
        formData.append('company_type',danweiArray.toString());
        formData.append('author',author);
        formData.append('description',description);
        formData.append('cover',cover);
        formData.append('content',content);
        formData.append('contact',tel);
        formData.append('smsmsg',code);
        formData.append('commit_file',commit_file)

        $.ajax({
            type: 'POST',
            url: 'http://sing.people.com.cn/api/articles/addzeren',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                console.log('提交信息:', res)
                if(res.code == 0){
                    alert(res.message)
                }else{
                    alert(res.message)
                }

            },
            error: function() {
   
            }
        })
    })
})